export default {
  title: {
    id: 'trade_in_apac_answer_summary_title',
    defaultMessage: 'Trade-in device details',
  },
}
